﻿

(function ($) {
    'use strict';

    $.fn.AgoraFileUpload = function (options) {

        var $_sender = $(this);
        var _self = this;
        var $_file = $_sender.find('input[type="file"]');
        var $_valueNode = $_sender.find('input[type="hidden"][node]');
        var $_label = $_sender.find('label');
        var $_itemContext = $_sender.find('.items-context');
        var $progress = $_sender.find('.progress');
        var $progressBar = $progress.find('div');
        var _serviceURL = $_sender.data('agora-file-upload');
        var _uploadPath = $_sender.data('agora-file-upload-path');
        var _fileId = $_sender.data('agora-file-id');
        var _fileIndex = $_sender.data('agora-file-index');
        var _autoGenerateThumb = typeof ($_sender.data('generate-thumb')) != 'undefined' && $_sender.data('generate-thumb') == true;
        var _isAutoGenerateThumbAction = false;
        var _fileSize = typeof ($_sender.data('file-size')) != 'undefined' ? $_sender.data('file-size') : 0;
        var _maxWidth = typeof ($_sender.data('max-width')) != 'undefined' ? $_sender.data('max-width') : -1;
        var _maxHeight = typeof ($_sender.data('max-height')) != 'undefined' ? $_sender.data('max-height') : -1;
        var _mimeType = $_file.attr('accept');

        var _onChange = (options != null && options.OnChange != null) ? options.OnChange : null;


        _self._send = function (headers, data, success) {

            $.ajax({
                headers: headers,
                type: 'POST',
                url: _serviceURL,
                data: data,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function (data) {
                    success(data);
                }
            });

        };

        _self._getData = function () {

            if ($_file.files.length > 0) {

            }
            return _formData;
        };

        _self._startProgress = function () {
            $_sender.addClass('is-busy');
            _self._updateProgress(0);
        };

        _self._updateProgress = function (count) {
            $progressBar.attr('data-value', Math.floor(count) + '%');
            $progressBar.width(count + '%');
        };

        _self._endProgress = function () {
            $_sender.removeClass('is-busy');
            _self._updateProgress(100);
        };

        _self._uploadComplete = function (response) {
            if (!_isAutoGenerateThumbAction) {
                _self._bindItems(response);
                if (_autoGenerateThumb) {
                    _isAutoGenerateThumbAction = !(_autoGenerateThumb = false);
                    for (var key in response) {
                        var $valueXml = $(response[key].xml);
                        _self._createSnapShot($valueXml.find('file').attr('url'), function (imageUrl) {
                            _self._sendFile(dataURLtoFile(imageUrl, 'poster.jpg'));
                        });
                    }
                }
            } else {
                _isAutoGenerateThumbAction = !(_autoGenerateThumb = true);
                for (var key in response) {
                    var $valueXml = $(response[key].xml);
                    var $fileValue = $($_valueNode.val());
                    $fileValue.find('file').attr('poster', $valueXml.find('file').attr('url'));
                    $_valueNode.val($fileValue[0].outerHTML);
                }
            }


            if (_onChange != null) {
                var value;
                if (response != null) {
                    for (var key in response) {
                        value = response[key].url;
                    }
                }
                _onChange(value);
            }
        };

        _self._bindItems = function (response) {
            $_itemContext.html('');
            for (var key in response) {
                $(_self._getItem(response[key])).appendTo($_itemContext);
                $_valueNode.val(response[key].xml);
            }

        };

        _self._removeItem = function ($item) {
            $item.remove();
            $_valueNode.val('');
        };

        _self._getItem = function (response) {
            var $result = $('<label></label>');
            $result.html('<b>' + response.name + '</b>');
            var $resultHidden = $('<input type="hidden" />');
            $resultHidden.val(response.xml);
            var $remove = $('<i></i>');
            $result.append($remove);
            $remove.on('click', function () { _self._removeItem($result); });
            return $result.append($resultHidden);
        };

        _self._sendFile = function (file, name, fileType, success) {
            if (!_isAutoGenerateThumbAction)
                _self._startProgress();
            var _chunksCompleted = 0;
            // create array to store the buffer chunks
            var FileChunk = [];
            // set up other initial vars
            var MaxFileSizeMB = 1;
            var BufferChunkSize = MaxFileSizeMB * (1024 * 1024);
            var ReadBuffer_Size = 1024;
            var FileStreamPos = 0;
            // set the initial chunk length
            var EndPos = BufferChunkSize;
            var Size = typeof (file.size) != 'undefined' ? file.size : file.length;
            var isSubFile = typeof (success) == 'function';

            // add to the FileChunk array until we get to the end of the file
            while (FileStreamPos < Size) {
                // "slice" the file from the starting position/offset, to  the required length
                FileChunk.push(file.slice(FileStreamPos, EndPos));
                FileStreamPos = EndPos; // jump by the amount read
                EndPos = FileStreamPos + BufferChunkSize; // set next chunk length
            }
            // get total number of "files" we will be sending
            var TotalParts = FileChunk.length;
            var PartCount = 0;
            // loop through, pulling the first item from the array each time and sending it
            var chunk;
            while (chunk = FileChunk.shift()) {
                PartCount++;
                // file name convention
                var FilePartName = _fileId + _fileIndex + ".part_" + PartCount + "." + TotalParts;
                // send the file
                var _headers = {
                    'X-File-Name': typeof (name) != 'undefined' ? name : file.name,
                    'X-File-Part-Name': FilePartName,
                    'X-File-Type': typeof (fileType) != 'undefined' ? fileType : file.type,
                    'X-File-Size': Size,
                    'X-File-Path': _uploadPath
                };
                var _formData = new FormData();
                _formData.append("fileitem", chunk, FilePartName);
                _self._send(_headers, _formData, _chunkComplete);
            }

            function _chunkComplete(data) {
                _chunksCompleted++;
                if (isSubFile) {
                    _fileIndex++;
                    success();
                } else {
                    if (_chunksCompleted == TotalParts) {
                        _self._uploadComplete(data);
                        _fileIndex++;
                        if (!_isAutoGenerateThumbAction)
                            _self._endProgress();
                        else
                            _self._updateProgress(99);
                    } else {
                        _self._updateProgress((_chunksCompleted / TotalParts) * 100);
                    }
                }
            }

        };

        function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        }

        _self._upload = function () {
            for (var i = 0; i < $_file[0].files.length; i++)
                if (_self._performValidation($_file[0].files[i])) {
                    var fileToUpload = $_file[0].files[i];
                    var fileName = fileToUpload.name;
                    var fileType = fileToUpload.type;
                    if (fileType.indexOf('image') > -1) {
                        _self.resizeImage(fileToUpload, fileType, function (updatedFileToUpload, webpFileToUpload) {
                            _self._sendFile(webpFileToUpload, undefined, undefined, function () {
                                _self._sendFile(updatedFileToUpload);
                            });
                        }, function (updatedFileToUpload) {
                            _self._sendFile(updatedFileToUpload);
                        });
                    } else {
                        _self._sendFile($_file[0].files[i]);
                    }
                }
        };

        _self.resizeImage = function (fileToUpload, fileType, success, fail) {
            if (_maxHeight == _maxWidth == "-1") success(fileToUpload);
            try {
                var image = new Image();
                image.crossOrigin = 'Anonymous';
                image.onload = function () {
                    try {
                        var canvas = document.createElement('canvas');
                        var resizerCanvas = document.createElement('canvas');
                        var context = canvas.getContext('2d');
                        var resizeContext = resizerCanvas.getContext('2d');
                        canvas.height = image.naturalHeight;
                        canvas.width = image.naturalWidth;
                        context.drawImage(image, 0, 0);
                        var scaleMaxWidth = _maxWidth != '0' ? parseInt(_maxWidth) : 1920;
                        var scaleMaxHeight = _maxHeight != '0' ? parseInt(_maxHeight) : 1080;
                        var scaleWidthConstant = scaleMaxWidth < image.naturalWidth ? (scaleMaxWidth / image.naturalWidth) : 1;
                        var scaleHeightConstant = scaleMaxHeight < image.naturalHeight ? (scaleMaxHeight / image.naturalHeight) : 1;
                        var scaleConstant = Math.min(scaleWidthConstant, scaleHeightConstant);
                        var scaleWidth = image.naturalWidth * scaleConstant;
                        var scaleHeight = image.naturalHeight * scaleConstant;
                        resizerCanvas.width = scaleWidth;
                        resizerCanvas.height = scaleHeight;
                        resizeContext.drawImage(canvas, 0, 0, scaleWidth, scaleHeight);
                        var resizedDataUrl = resizerCanvas.toDataURL(fileType, 0.7);
                        var webpResizedDataUrl = fileType != 'image/webp' ? resizerCanvas.toDataURL('image/webp', 0.7) : resizedDataUrl;
                        success(dataURLtoFile(resizedDataUrl, fileToUpload.name), dataURLtoFile(webpResizedDataUrl, 'O_'+fileToUpload.name.replace(/\.[A-z]{3,4}/gi,'.webp')));
                    } catch (e) { fail(fileToUpload); }
                };
                image.onerror = function () {
                    fail(fileToUpload);
                };

                var readerFileData = new FileReader();
                readerFileData.addEventListener('load', function () {
                    image.src = readerFileData.result;
                });

                readerFileData.readAsDataURL(fileToUpload);

            } catch (e) { fail(fileToUpload); }

        }

        _self._performValidation = function (file) {
            if (_fileSize > 0 && file.size > _fileSize) {
                alert('File size limit exceeded!');
                return false;
            }
            if (typeof (_mimeType) != 'undefined' && _mimeType.trim() != '' && _mimeType.trim() != "*") {
                var _fileTypes = _mimeType.split(',');
                var _validFileType = false;
                for (var key in _fileTypes) {
                    var _fileTypeToCheck = _fileTypes[key].replace('*', '');
                    _validFileType |= !(file.type.indexOf(_fileTypeToCheck) == -1);
                }
                if (!_validFileType) {
                    alert('File type not supported!');
                    return false;
                }
            }
            return true;
        };

        _self._createSnapShot = function (url, success) {
            var $body = $('body');
            var $wrapper = $('<div class="video-process mdl-cell--hide"></div>');
            var $video = $('<video crossorigin="anonymous" muted playsinline width="640" height="480"></video>');
            var $source = $('<source src="' + url + '" type="video/mp4" />');
            var $canvas = $('<canvas width="640" height="480"></canvas>');

            $video.append($source);
            $wrapper.append($video).append($canvas);
            $body.append($wrapper);

            var canvas = $canvas[0];
            var video = $video[0];
            var context = canvas.getContext('2d');
            var isStarted = false;

            video.addEventListener('loadedmetadata', function () {
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
            });

            video.addEventListener('canplay', function () {
                if (!isStarted) {
                    isStarted = true;
                    video.pause();
                    buildSnap();
                }
            });

            video.play();

            function buildSnap() {
                context.drawImage(video, 0, 0, canvas.width, canvas.height);
                try {
                    success(canvas.toDataURL('image/jpeg', 0.6));
                } catch (e) {
                    console.error('Canvas snapshot failed (possibly CORS issue):', e);
                    success(null); // or handle error
                }
                $wrapper.remove();
            }
        };

        _self._init = function () {
            $_file.bind('change', function () {
                //console.log('File change');
                _self._upload();
            });
            $_sender.find('.items-context label>i').on('click', function () { _self._removeItem($(this).closest('label')); });
        };
        _self._init();
    }

}(jQuery));